var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpiRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21.68,
    viewBox: "0 0 20 21.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history-15",
    transform: "translate(-39.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24966",
    "data-name": "Path 24966",
    d: "M691.371,568.8h-2.927V566.3a.542.542,0,0,0-1.084,0v3.035a.512.512,0,0,0,.542.542h3.469a.512.512,0,0,0,.542-.542A.543.543,0,0,0,691.371,568.8Z",
    transform: "translate(-633.967 -553.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24967",
    "data-name": "Path 24967",
    d: "M432.148,463.36h0a5.908,5.908,0,1,0,0,11.816h0a5.908,5.908,0,1,0,0-11.816Zm0,10.732a4.824,4.824,0,1,1,4.824-4.824A4.835,4.835,0,0,1,432.148,474.092Z",
    transform: "translate(-378.376 -453.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24968",
    "data-name": "Path 24968",
    d: "M217.191,323.1a.512.512,0,0,0-.542-.542H206.622a.542.542,0,1,0,0,1.084h10.027A.543.543,0,0,0,217.191,323.1Z",
    transform: "translate(-162.877 -315.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24969",
    "data-name": "Path 24969",
    d: "M210.687,530.462a.512.512,0,0,0-.542-.542h-3.523a.542.542,0,0,0,0,1.084h3.523A.543.543,0,0,0,210.687,530.462Z",
    transform: "translate(-162.877 -518.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24970",
    "data-name": "Path 24970",
    d: "M206.622,709.12a.542.542,0,1,0,0,1.084h2.71a.542.542,0,1,0,0-1.084Z",
    transform: "translate(-162.877 -694.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24971",
    "data-name": "Path 24971",
    d: "M49.057,20.6H40.764V1.084H44.45V1.9A1.321,1.321,0,0,0,45.7,3.252c.271,0,7.263.054,7.913,0a1.2,1.2,0,0,0,1.192-1.3V1.138h3.686v9.268a.542.542,0,1,0,1.084,0V.6A.512.512,0,0,0,59.03.054H54.26A.512.512,0,0,0,53.718.6V1.951a.248.248,0,0,1-.217.271H45.75a.256.256,0,0,1-.271-.271V.542A.512.512,0,0,0,44.937,0H40.222a.512.512,0,0,0-.542.542v20.6a.512.512,0,0,0,.542.542h8.835a.512.512,0,0,0,.542-.542A.543.543,0,0,0,49.057,20.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24972",
    "data-name": "Path 24972",
    d: "M370.462,1.084h4.878a.512.512,0,0,0,.542-.542A.512.512,0,0,0,375.34,0h-4.878a.512.512,0,0,0-.542.542A.543.543,0,0,0,370.462,1.084Z",
    transform: "translate(-323.248)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiRequest);
export default __webpack_public_path__ + "static/media/kpi-request.b5afd343408d5e36f2997d49e2e1a7ad.svg";
export { ForwardRef as ReactComponent };